"use client";

import { defaultLocale, isLocale } from "@/i18n/config";
import { localizeHref } from "@/i18n/navigation";
import { authClient } from "@/lib/auth/client";
import { useLocale, useTranslations } from "next-intl";
import { useRouter } from "next/navigation";
import { toast } from "sonner";

export function useSignOut() {
    const router = useRouter();
    const rawLocale = useLocale();
    const locale = isLocale(rawLocale) ? rawLocale : defaultLocale;
    const t = useTranslations("nav");

    const signOut = async () => {
        try {
            const { error } = await authClient.signOut();

            if (error) {
                toast.error(t("signOutFailedTitle"), {
                    description: error.message ?? t("signOutRetry"),
                });
                return;
            }

            localStorage.removeItem("use-store");
            localStorage.removeItem("use-store_ts");
            toast.success(t("signOutSuccessTitle"), {
                description: t("signOutSuccessDesc"),
            });
            router.replace(localizeHref("/login", locale));
            router.refresh();
        } catch {
            toast.error(t("signOutFailedTitle"), {
                description: t("signOutRetry"),
            });
        }
    };

    return { signOut };
}
